import { RootState } from '../storeTypes';

export const getUserDtosSelector = (state: RootState) => state.usersState.users;
